import i18n from '../languages';
export const LOAD_INERTIA_TYPES = [
    {
        id: 'cylinder',
        name: i18n.t('inertiaTool.model_options.model_cylinder'),
        hasSolid: true,
        hasHollow: true,
        formula: (solid, m, r) => (solid ? (1 / 2) * m * r ** 2 : m * r ** 2),
    },
    {
        id: 'disk',
        name: i18n.t('inertiaTool.model_options.model_disk'),
        hasSolid: true,
        hasHollow: true,
        formula: (solid, m, r) => (solid ? (1 / 2) * m * r ** 2 : m * r ** 2),
    },
    {
        id: 'sphere',
        name: i18n.t('inertiaTool.model_options.model_sphere'),
        hasSolid: true,
        hasHollow: true,
        formula: (solid, m, r) => (solid ? (2 / 5) * m * r ** 2 : (2 / 3) * m * r ** 2),
    },
    {
        id: 'cone',
        name: i18n.t('inertiaTool.model_options.model_cone'),
        hasSolid: true,
        hasHollow: true,
        formula: (solid, m, r) => (solid ? (3 / 10) * m * r ** 2 : (1 / 2) * m * r ** 2),
    },
    {
        id: 'cuboid',
        name: i18n.t('inertiaTool.model_options.model_cuboid'),
        hasSolid: true,
        hasHollow: false,
        formula: (_solid, m, w, h) => (1 / 12) * m * (w ** 2 + h ** 2),
    },
    {
        id: 'rectangle',
        name: i18n.t('inertiaTool.model_options.model_rectangle'),
        hasSolid: true,
        hasHollow: false,
        formula: (_solid, m, w, h) => (1 / 12) * m * (w ** 2 + h ** 2),
    },
    {
        id: 'point-mass',
        name: i18n.t('inertiaTool.model_options.model_point-mass'),
        hasSolid: false,
        hasHollow: false,
        formula: (_solid, m, r) => m * r ** 2,
    },
];
